import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import FeatureSection from './components/FeatureSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import JsonLd from '@/components/seo/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL;

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'OOPBuySpread.de',
      url: siteUrl,
      logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
      description: 'Die größte deutschsprachige Plattform für OOPBuy Spreadsheet, Produktlisten, Guides und Einkaufshilfen.',
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'OOPBuySpread.de',
      description: 'OOPBuy Spreadsheet Deutschland – Finde die besten Produkte schneller mit organisierten Produktlisten und Experten-Guides.',
      publisher: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'de-DE',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'OOPBuy Spreadsheet Deutschland – Finde die besten Produkte schneller',
      description: 'Entdecke organisierte Produktlisten, aktuelle Finds, Produktvergleiche und Experten-Guides für OOPBuy Nutzer aus Deutschland.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'de-DE',
      datePublished: '2026-07-15',
      dateModified: '2026-07-15',
    },
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <main className="min-h-screen bg-background-50">
        <Navbar />
        <Hero />
        <CategorySection />
        <FeatureSection />
        <div id="ratgeber">
          <ArticleSection />
        </div>
        <CTASection />
        <FAQSection />
        <Footer />
      </main>
    </>
  );
}